import { authRoles } from 'app/auth';
import EdaViewPage from './component/EdaViewPage';
import EdaTable from './table/EdaTable';

export default [
	{
		path: '/eda/view/:id',
		component: EdaViewPage,
		auth: authRoles.eda
	},
	{
		path: '/eda/:sessionNameParam?',
		component: EdaTable,
		auth: authRoles.eda
	}
];
